module.exports = __webpack_public_path__ + "static/media/mobile_mockup_dark.04ee97dc.svg";